import { SUITS } from "@/lib/deck";
import { cn } from "@/lib/utils";

const SUIT_MAP = Object.fromEntries(SUITS.map((s) => [s.id, s]));

export function DealLog({ history }) {
  const entries = [...history].reverse();
  return (
    <div className="border-2 border-foreground bg-card" data-testid="deal-log">
      <div className="flex items-center justify-between px-4 pt-4 pb-2">
        <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Deal Log</span>
        <span className="text-xs font-bold tabular-nums" data-testid="deal-log-count">
          {history.length}
        </span>
      </div>
      <div className="border-t-2 border-foreground p-3 max-h-48 overflow-y-auto">
        {entries.length === 0 ? (
          <p className="text-xs text-muted-foreground py-2" data-testid="deal-log-empty">
            No cards dealt yet.
          </p>
        ) : (
          <div className="flex flex-wrap gap-1.5" data-testid="deal-log-list">
            {entries.map((id, i) => {
              const [suitId, rank] = id.split("-");
              const suit = SUIT_MAP[suitId];
              return (
                <span
                  key={`${id}-${entries.length - i}`}
                  data-testid="deal-log-entry"
                  className={cn(
                    "inline-flex items-center gap-0.5 border border-foreground px-1.5 py-0.5 text-xs font-bold bg-background",
                    suit.color === "red" ? "text-suit-red" : "text-suit-black"
                  )}
                >
                  {rank}
                  <span aria-hidden="true">{suit.symbol}</span>
                </span>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
